<template>
  <div class="workBench">
    <div class="intro-y box overflow-hidden mt-5 title">
      <img :src="user.imgUrl" alt="">
      <div>
        <div class="tit-word">您好，{{user.name}}，祝你开心每一天！</div>
        <div>{{user.adminFlag ? "公司领导" : "业务操作员"}}  |  {{user.parentCompanyName}}－{{user.companyName}}</div>
      </div>
    </div>
    <div class="pos intro-y grid grid-cols-12 gap-5 mt-5">
      <!-- BEGIN: Post Content -->
      <div class="intro-y col-span-12 lg:col-span-8">
        <div class="post intro-y overflow-hidden box mt-5">
          <dataStatistics/>
        </div>
        <div class="post intro-y overflow-hidden mt-5">
          <information/>
        </div>
      </div>
      <!-- END: Post Content -->
      <!-- BEGIN: Post Info -->
      <div class="col-span-12 lg:col-span-4">
        <div class="post intro-y overflow-hidden box mt-5">
          <tips/>
        </div>
        <div class="post intro-y overflow-hidden box mt-5">
          <companyUser :adminFlag="user.adminFlag"/>
        </div>
      </div>
      <!-- END: Post Info -->
    </div>
    <p style="text-align: center;margin-top:24px;">copyright© 2020 上海百昌科技出品</p>
  </div>
</template>

<script>
  import dataStatistics from './components/dataStatistics'
  import information from './components/information'
  import tips from './components/tips'
  import companyUser from './components/companyUser'
  import {getList} from '../../api/asset.js'
  import {mapState} from 'vuex'
  export default {
    name: "workBench",
    components: {
      dataStatistics,
      information,
      tips,
      companyUser
    },
    data() {
      return {

      }
    },
    methods: {

    },
    created() {
    },
    computed: {
      ...mapState({
        user:state=>state.user.user
      })
    }
  }
</script>


<style scoped lang="scss">
  .workBench {
    min-height: calc(100vh - 84px);
    .title {
      width: 100%;
      height: 140px;
      background: #fff;
      padding:24px;
      display: flex;
      img{
        display: inline-block;
        width: 80px;
        height: 80px;
        border-radius: 50%;
        margin-right: 24px;
      }
      .tit-word {
        color: #000;
        font-size: 26px;
        margin-bottom: 24px;
      }
    }


  }
</style>
